module.exports = __webpack_public_path__ + "20d26350bd5750c909a6295d0fbdff62.svg";